module.exports = __webpack_public_path__ + "img/soeko_white.b4aaab16.png";